<template>
  <footer class="py-5">
    <ul class="px-5 mt-2">
      <li v-for="(link, index) in footerLinks" :key="index" class="mb-3">
        <a :href="link.url" :target="link.target" class="text-base group font-futuraEfBook" :class="[{ underline: link.isSelected }]" role="menuitem" :data-testid="`mobileMenuFooterLink-${index}`">{{ link.text }}</a>
      </li>
      <li v-if="footerLanguage && footerLanguage.url && footerLanguage.label" class="pt-1 text-white border-solid">
        <a :href="footerLanguage.url" class="inline-flex items-center ellevio-lang-switch" :aria-label="translations?.ariaLabels?.changeLanguage" data-testid="mobileMenuFooterLangSwitch">
          <span class="pl-1 text-xs text-newColors-gray-content font-futuraEfDemiBold" data-testid="mobileMenuFooterLangSwitchText">{{ footerLanguage.label }}</span>
        </a>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'EllevioWebMobileNavFooter',
  props: {
    footerLinks: {
      type: Array
    },
    footerLanguage: {
      type: Object
    },
    translations: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
